import React from 'react';
import Relay from 'react-relay';
import { css } from 'glamor';

import { FormattedMessage } from 'react-intl';

import { FAMILY_EXTENDED_BOLD } from 'depop/styles/typography';
import { DARK_RED, RED, YELLOW, WHITE, BLACK } from 'depop/styles/colors';

import isSold from 'depop/utils/isSold';

import { downloadConnector } from 'depop/connectors';

import { trackBuyProduct } from 'depop/utils/tracking';

class BuyButton extends React.Component {
  state: {
    isModalVisible: Boolean,
  };

  props: {
    link: String,
    product: ?Object,
    from: ?String,
    listIndex: ?String,
    openDownload: () => void,
  };

  clickBuy = () => {
    const { product, openDownload, from: source, listIndex } = this.props;
    trackBuyProduct({
      username: product.seller.username,
      id: product.publicId,
      slug: product.slug,
      price: product.price.display,
      currency: product.price.currency,
      source,
      similarItemIndex: source === 'similar items' ? listIndex : undefined,
    });
    openDownload();
  };

  clickBuyOnApp = () => {
    const { product, openDownload, from: source, listIndex } = this.props;
    trackBuyProduct({
      username: product.seller.username,
      id: product.publicId,
      slug: product.slug,
      price: product.price.display,
      currency: product.price.currency,
      source,
      similarItemIndex: source === 'similar items' ? listIndex : undefined,
    });
  };

  render() {
    const { product, link } = this.props;
    const href = link ? link + '?channel=buy%20button' : 'javascript:;';
    const onClick = link ? this.clickBuyOnApp : this.clickBuy;

    const baseStyles = {
      display: 'inline-block',
      verticalAlign: 'bottom',
      fontSize: 16,
      lineHeight: '30px',
      fontFamily: FAMILY_EXTENDED_BOLD,
      textDecoration: 'none',
      color: WHITE,
    };

    const buyStyle = {
      ...baseStyles,
      backgroundColor: BLACK,
      border: `1px solid ${BLACK}`,
      padding: '0 30px',
    };

    if (isSold(product)) {
      return (
        <a {...css(baseStyles)}>
          <FormattedMessage
            id="BuyButton.Sold"
            defaultMessage="Sold on the app" />
        </a>
      );
    }

    return (
      <a
        {...css(buyStyle)}
        href={href}
        onClick={onClick}>
        <FormattedMessage
          id="BuyButton.Buy"
          defaultMessage="Buy on the app" />
      </a>
    );
  }
};

export default Relay.createContainer(downloadConnector(BuyButton), {
  fragments: {
    product: () => Relay.QL`
      fragment on Product {
        publicId
        slug
        price {
          currency
          display
        }
        seller {
          username
        }
        saleStatus
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/apps/shops/components/BuyButton.js